import { useState } from 'react';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { submitProposal, withdrawProposal, type RateLineProposalView } from '../../../rate-cards.api';

export type ProposalAction =
  { kind: 'edit'; proposal: RateLineProposalView } | { kind: 'submit'; proposal: RateLineProposalView } | { kind: 'withdraw'; proposal: RateLineProposalView };

/** The author's three actions on a draft, one open at a time: which is open, and what confirming it does and says. */
export function useProposalActions(onDone: () => void) {
  const [action, setAction] = useState<ProposalAction | null>(null);
  const toast = useToast();

  async function submit(proposal: RateLineProposalView, reason: string) {
    await submitProposal(proposal.id, reason);
    toast.success('Proposal submitted for approval');
    onDone();
  }

  async function withdraw(proposal: RateLineProposalView, reason: string) {
    await withdrawProposal(proposal.id, reason);
    toast.success('Proposal withdrawn');
    onDone();
  }

  return { action, open: setAction, close: () => setAction(null), submit, withdraw };
}
